/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { FC } from 'react';
import { Badge, Switch } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { GeoArea } from '../types';

const useStyles = makeStyles(() => ({
	root: {
		paddingLeft: 3,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		textAlign: 'left',
		'& .MuiBadge-root': {
			marginRight: 8,
			marginTop: -2
		}
	}
}));

type TreeNodeLabelProps = {
	geoAreaId: GeoArea['id'];
	geoAreaName: GeoArea['name'];
	toggleIsChecked: boolean;
	showToggle: boolean;
	onClick: () => void;
};

const TreeNodeLabel: FC<TreeNodeLabelProps> = ({
	geoAreaId,
	geoAreaName,
	toggleIsChecked,
	showToggle,
	onClick
}: TreeNodeLabelProps) => {
	const classes = useStyles();

	const showIndicator = false;

	const handleClick: React.MouseEventHandler = (event): void => {
		event.stopPropagation();
		onClick();
	};

	return (
		<div id={geoAreaId} className={classes.root} onClick={handleClick}>
			<span>
				{showIndicator && <Badge badgeContent={''} variant="dot" color={'secondary'} />}
				{geoAreaName}
			</span>

			{showToggle && (
				<span>
					<Switch
						color={'primary'}
						checked={toggleIsChecked}
						size={'small'}
						title={`Unterebenen von ${geoAreaName} darstellen`}
					/>
				</span>
			)}
		</div>
	);
};

export default TreeNodeLabel;
